export default {
  AdmissionTableConfig: 'AdmissionTableConfig',
}
